import chatService from "../api/chatService";

export async function chatWithAI(
  query,
  conversationId,
  questionId,
  threadId,
  concise,
  taggedItems,
  model,
  domainId = null,
  assistantMode,
  thinkingMode,
  streamResponse
) {
  try {
    const response = await chatService.chatWithAI(
      query,
      conversationId,
      questionId,
      threadId,
      taggedItems,
      concise,
      model,
      domainId,
      assistantMode,
      thinkingMode
    );
    const reader = response.getReader();
    const decoder = new TextDecoder();

    let steamResp = "";
    let sseBuffer = ""; // Buffer to hold partial SSE frames across chunks
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      const chunkText = decoder.decode(value, { stream: true });

      // Accumulate chunk into buffer and split by SSE message delimiter "\n\n"
      sseBuffer += chunkText;
      const frames = sseBuffer.split("\n\n");

      // Keep the last potentially incomplete frame in the buffer
      sseBuffer = frames.pop() || "";

      // Process complete frames
      for (const frame of frames) {
        if (!frame) continue;
        // An SSE frame may contain multiple lines starting with "data: "
        // Strip the exact "data: " (or "data:") prefix per line and preserve the rest as-is
        const lines = frame.split("\n");
        const payload = lines
          .map((line) =>
            line.startsWith("data: ")
              ? line.slice(6)
              : line.startsWith("data:")
              ? line.slice(5)
              : line
          )
          .join("\n");

        steamResp += payload;
      }

      // Emit the accumulated response so far
      streamResponse(steamResp);
    }

    // Optionally, if the stream ended and there is a leftover frame without delimiter
    // we can conservatively ignore it to avoid emitting partial frames.
  } catch (error) {
    throw error;
  }
}

export async function getChatMetaData(questionId) {
  try {
    const response = await chatService.getChatMetaData(questionId);
    return response;
  } catch (error) {
    throw error;
  }
}

export function getQueryIntent(
  query,
  conversationId,
  questionId,
  threadId,
  concise,
  taggedItems,
  model,
  domainId = null
) {
  return async (dispatch) => {
    try {
      const response = await chatService.getQueryIntent(
        query,
        conversationId,
        questionId,
        threadId,
        taggedItems,
        concise,
        model,
        domainId
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function getEntity(
  queryIntent,
  query,
  conversationId,
  questionId,
  threadId,
  concise,
  taggedItems,
  model,
  domainId = null
) {
  return async (dispatch) => {
    try {
      const response = await chatService.getEntity(
        queryIntent,
        query,
        conversationId,
        questionId,
        threadId,
        taggedItems,
        concise,
        model,
        domainId
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function getQueryTabularData(
  queryIntent,
  query,
  conversationId,
  questionId,
  threadId,
  concise,
  fileIds,
  model,
  domainId = null
) {
  return async (dispatch) => {
    try {
      const response = await chatService.getQueryTabularData(
        queryIntent,
        query,
        conversationId,
        questionId,
        threadId,
        fileIds,
        concise,
        model,
        domainId
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function getPidResponse(
  queryIntent,
  query,
  conversationId,
  questionId,
  threadId,
  concise,
  taggedItems,
  model,
  domainId = null
) {
  return async (dispatch) => {
    try {
      const response = await chatService.getPidResponse(
        queryIntent,
        query,
        conversationId,
        questionId,
        threadId,
        taggedItems,
        concise,
        model,
        domainId
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
}
